/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { Fragment } from 'react';
import { Menu } from '../menu';
import { getOverride, getPath, getTextContrast, setSubscriptionRedirect } from '../../../utils';
import { SocialFollow } from '../../basic/social-follow/social-follow';
import get from 'lodash/get';
import { SvgHandler } from '../../svg-handler/svg-handler';
import { MobileDownloadLinks } from '../../atoms/mobile-apps';
import closeIcon from '../../../../assets/icons/social/close.svg';
import PropTypes from 'prop-types';
import './sidebar.module.css';

class SidebarTemplate extends React.Component {
  updateCloseSidebar = e => {
    e.stopPropagation();

    return this.props.closeSidebar();
  };

  render () {
    let {
      isSidebarVisible,
      menuItems,
      socialLinks,
      languageDirection = 'ltr',
      customCssClasses,
      toggleSidebar,
      closeAll,
      headerClass = '',
      pageBuilderConfig = {},
      socialStyle = {},
      localizedSubscribe,
      sketchesHost,
      memberSubscriptions = []
    } = this.props;
    const hasActiveSubscription = memberSubscriptions.some(sub => sub.status === 'active' || sub.active);
    const {
      enableAppDownloadLinksButton: enableAppDownloadLinks = true,
      enableSubscriptionButton = false,
      enableSSO: isSSOEnabled = false,
      primaryBackgroundColor = '',
      headerStyle = 'header_1'
    } = get(pageBuilderConfig, ['header'], {});
    const textContrast = getTextContrast(primaryBackgroundColor);
    const sidebar = {
      header_2: 'open-right',
      header_4: 'open-right',
      'single-layer-header_2': 'open-right',
      'single-layer-header_5': 'open-right'
    };
    const getSidebarClass = new Proxy(sidebar, getOverride('open-left'));

    const sidebarOverlay = {
      header_2: 'overlay-open-right',
      header_4: 'overlay-open-right',
      'single-layer-header_2': 'overlay-open-right',
      'single-layer-header_5': 'overlay-open-right'
    };
    const getSidebarOverlayClass = new Proxy(sidebarOverlay, getOverride('overlay-open-left'));

    const sidebarOverride = {
      header_2: 'override-sidebar-header-2',
      header_4: 'override-sidebar-header-4',
      'single-layer-header_2': 'override-sidebar-single-header-2'
    };
    const getsidebarOverrideClass = new Proxy(sidebarOverride, getOverride(''));
    const whiteListedUrlParams = get(pageBuilderConfig, ['general', 'others', 'whiteListedUrlParams'], []);
    const subscriptionUrl = getPath({
      sketchesHost,
      relativePath: '/subscription',
      injectCustomParams: true,
      whiteListedUrlParams
    });
    return (
      <Fragment>
        <div
          styleName={`overlay ${customCssClasses} ${isSidebarVisible ? 'overlay--active' : ''} ${
            getSidebarOverlayClass[headerStyle]
          }`}
          onClick={this.closeSidebar}
        />
        <div
          styleName={`sidebar sidebar--visible ${customCssClasses} ${headerClass} ${getSidebarClass[headerStyle]} ${
            getsidebarOverrideClass[headerStyle]
          } ${!isSSOEnabled ? 'no-login-pos' : ''}`}
        >
          <SvgHandler
            xlinkHref={closeIcon}
            clazzName='sidebarCloseIcon'
            width='24'
            height='24'
            svgWrapperClazzName='svg-wrapper'
          />
          <nav>
            <Menu
              closeAll={closeAll}
              menu={menuItems}
              sidebar
              languageDirection={languageDirection}
              toggleSidebar={toggleSidebar}
              customCssClasses={`sidebar ${headerClass}`}
            />
          </nav>
          {enableAppDownloadLinks && <MobileDownloadLinks />}
          <div styleName='cta-wrapper'>
            <SocialFollow
              contrastAgainstBg={textContrast}
              hasBackground={true}
              socialLinks={socialLinks}
              socialStyle={socialStyle}
              customCssClasses='sidebar'
              isSidebar
            />
            {enableSubscriptionButton && !hasActiveSubscription && (
              <span
                styleName='btn'
                onClick={() => setSubscriptionRedirect(subscriptionUrl, sketchesHost, whiteListedUrlParams)}
                id='sidebar-subscribe-button'
              >
                {localizedSubscribe || 'Subscribe'}
              </span>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

SidebarTemplate.propTypes = {
  headerConfig: PropTypes.object,
  menuItems: PropTypes.array,
  socialLinks: PropTypes.object,
  languageDirection: PropTypes.string,
  customCssClasses: PropTypes.string,
  toggleSidebar: PropTypes.func,
  closeAll: PropTypes.func,
  closeSidebar: PropTypes.func,
  isSidebarVisible: PropTypes.bool,
  headerClass: PropTypes.string,
  config: PropTypes.object,
  isSingleLayer: PropTypes.bool,
  pageBuilderConfig: PropTypes.object,
  socialStyle: PropTypes.object,
  enableAppDownloadLinks: PropTypes.bool,
  localizedSubscribe: PropTypes.string,
  sketchesHost: PropTypes.string
};

export default SidebarTemplate;
